
const Q = require('q');
const _ = require('lodash');
const server = require('server');
const page = require('page-common');
import ko from 'rgs-knockout';
const contextBar = require('context-bar');
const ContextBarContentCalcWorking = contextBar.ContentCalcWorking;
const complaintsForm = require('./model.js');

const formSubmit = (function () {
	let busy = false;

	return function formSubmit (_model, options) {
		const model = _model();
		model.Captcha.Value.clearError();
		model.EmailCheck.Value.clearError();
		if (!model.ValidationGroup().isValid()) {
			model.ValidationGroup().showAllMessages(true);
			return;
		}

		if (model.WorkingState() !== 'working' || busy) {
			return;
		}

		busy = true;

		function sendEmailCode () {
			model.WorkingState('sendingCode');
			return createCode({
				data: {
					Key: model.ContactInfo.xEmail(),
					Code: '',
				},
			}).then(function () {
				model.EmailCheck.SentToEmail(model.ContactInfo.xEmail());
			}).fin(function (){
				model.WorkingState('working');
			});
		}

		function checkEmailCode () {
			return sendConfirmCode({
				data: {
					Key: model.ContactInfo.xEmail(),
					Code: model.EmailCheck.Value(),
				},
			}).then(function (response) {
				const data = response.responseJSON;
				if (!data.result){
					model.EmailCheck.Value.setError('Код указан неверно');
					return;
				}
				model.EmailCheck.PassedByEmail(model.ContactInfo.xEmail());
				model.EmailCheck.Value.clearError();
			});
		}

		function submit () {
			if (!model.EmailCheck.Passed() && !model.EmployeeMode()) {
				return;
			}
			model.WorkingState('submiting');

			const headers = !model.EmployeeMode()
				? { 'Captcha': `${model.Captcha.Key()} ${model.Captcha.Value()}` }
				: {};

			server.any.api.complaint.submit({
				body: model.toJS(),
				headers: headers,
			}).then(function (response) {
				const data = response.responseJSON;
				if (!data.Success) {
					if (!model.EmployeeMode()) {
						_model(new complaintsForm({
							EmployeeMode: options.context.isEmployeeMode,
						}));
						_model().WorkingState('working');
						_model().isReady(true);
					}
					page.notifications.push({
						css: { 'notification-danger': true },
						message: 'Произошла непредвиденная ошибка. Пожалуйста, попробуйте позднее.',
					});
					return;
				}
				model.ComplaintId(data.UserCaseId);
				model.WorkingState('submit');
			}).catch(function (e){
				if (e.name === 'CaptchaValidationException') {
					model.Captcha.Value.setError('код указан неверно');
					e.handled = { type: 'silently' };
				} else if (!model.EmployeeMode()) {
					_model(new complaintsForm({
						EmployeeMode: options.context.isEmployeeMode,
					}));
					_model().WorkingState('working');
					_model().isReady(true);
				}
				throw e;
			}).fin(function (){
				generateKey(model);

				if (model.WorkingState() !== 'submit') {
					model.WorkingState('working');
				}
			});
		}

		let pipeline = Q();

		if (model.EmployeeMode()) {
			pipeline = pipeline
				.then(submit);
		} else if (!model.EmailCheck.Sent()) {
			pipeline = pipeline
					.then(sendEmailCode);
		} else if (!model.EmailCheck.Passed()) {
			pipeline = pipeline
					.then(checkEmailCode)
					.then(submit);
		} else {
			pipeline = pipeline
					.then(submit);
		}

		pipeline.finally(() => {
			busy = false;
		}).done();
	};
}());

function createCode (options) {
	options = _.defaultsDeep({}, options, { data: {
		TypeGenerator: 'ComplaintsKeyCodeManager',
		ProductTypeId: 0,
	},
	});
	return server.any.api.keyCode.createCode(options);
}

function sendConfirmCode (options) {
	options = _.defaultsDeep({}, options, { data: {
		TypeGenerator: 'ComplaintsKeyCodeManager',
		ProductTypeId: 0,
	},
	});
	return server.any.api.keyCode.checkCode(options);
}

function generateKey (model){
	server.any.cmsapi.captcha.generateKey()
		.then(function (response) {
			model.Captcha.Key(response.responseJSON);
		});
}

function controller (options) {
	const _model = ko.observable(new complaintsForm({
		EmployeeMode: options.context.isEmployeeMode,
		HomeUrl: options.homeUrl,
	}));

	const contextBarContentSend = new ContextBarContentCalcWorking({
		name: 'calc-feedback/sending',
		above: ['default'],
		visible: ko.pureComputed(function () {
			return _model().WorkingState() === 'sendingCode';
		}),
		calcWorking: {
			progress: 1,
			message: 'Идет отправка кода...',
		},
	});

	const contextBarContentSubmit = new ContextBarContentCalcWorking({
		name: 'calc-feedback/submiting',
		above: ['default'],
		visible: ko.pureComputed(function () {
			return _model().WorkingState() === 'submiting';
		}),
		calcWorking: {
			progress: 1,
			message: 'Идет сохранение заявки...',
		},
	});

	const contextBarContentUploadingFile = new ContextBarContentCalcWorking({
		name: 'calc-feedback/uploading-file',
		above: ['default'],
		visible: ko.pureComputed(function () {
			return _model().UploadingFiles().length > 0;
		}),
		calcWorking: {
			progress: 1,
			message: 'Идет сохранение файла...',
		},
	});


	generateKey(_model());

	ko.computed(function () {
		const model = _model();
		ko.ignoreDependencies(function () {
			model.on('formSubmit', (data, ...rest) => formSubmit(data, options, ...rest));
			model.Categories.api.init(options.AssembledCategories);
			model.Categories.api.setDefaultCategory(options.defaultCategory);
			model.ClaimSettlement.VehicleMakersList(options.MakersList);
			model.SelectOffice.RegionsList(options.RegionsList);
			model.ContactInfo.RegionsList(options.RegionsList);
		}, this);
	});

	

	ko.applyBindings({ model: _model }, options.container);

	page.contextBar.add(contextBarContentSend);
	page.contextBar.add(contextBarContentSubmit);
	page.contextBar.add(contextBarContentUploadingFile);

	//----------- region computed -----------------
	ko.computed(function (){
		if (!_model().SelectOffice.CurrentRegion()) {
			return;
		}

		ko.ignoreDependencies(function () {
			_model().SelectOffice.RgsOfficeCityUpdating(true);
		}, this);
		server.any.api.offices.getAllCities({
			query: { regionId: _model().SelectOffice.CurrentRegion().id },
		}).then(function (response){
			const data = response.responseJSON;
			ko.ignoreDependencies(function () {
				_model().SelectOffice.CitiesList(data.Data);
			}, this);
		}).fin(function (){
			ko.ignoreDependencies(function () {
				_model().SelectOffice.RgsOfficeCityUpdating(false);
			}, this);
		}).done();
	});

	ko.computed(function (){
		if (!_model().SelectOffice.RgsOfficeCity()) {
			return;
		}

		ko.ignoreDependencies(function () {
			_model().SelectOffice.RgsOfficeDivisionUpdating(true);
		}, this);
		server.any.api.offices.getOffices({
			query: {
				region: _model().SelectOffice.CurrentRegion.peek().name,
				city: _model().SelectOffice.RgsOfficeCity(),
				district: '',
				street: '',
				metro: '',
				lat: '',
				lng: '',
			},
		}).then(function (response) {
			const data = response.responseJSON;
			ko.ignoreDependencies(function () {
				_model().SelectOffice.OfficesList(data.offices.Data.offices);
			}, this);
		}).fin(function (){
			ko.ignoreDependencies(function () {
				_model().SelectOffice.RgsOfficeDivisionUpdating(false);
			}, this);
		}).done();
	});

	ko.computed(function () {
		if (!_model().ClaimSettlement.VehicleMaker()) {
			return;
		}

		ko.ignoreDependencies(function () {
			_model().ClaimSettlement.VehicleModelUpdating(true);
		}, this);
		server.any.api.dictionary.models({
			query: { makerId: _model().ClaimSettlement.VehicleMaker(), allCategories: true },
		}).then(function (response){
			const data = response.responseJSON;
			ko.ignoreDependencies(function () {
				_model().ClaimSettlement.VehicleModelsList(data);
			}, this);
		}).fin(function (){
			ko.ignoreDependencies(function () {
				_model().ClaimSettlement.VehicleModelUpdating(false);
			}, this);
		}).done();
	});

	ko.computed(function () {
		_.each(_model().KbmOsago.Policies(), function (v) {
			ko.ignoreDependencies(function () {
				v.UnlimitedDriversValue.extend({
					required: {
						params: true,
						onlyIf: function () {
							return _model().ContactInfo.IsIndividual();
						},
					},
				});
				v.OwnerTypeValue.extend({
					required: {
						params: true,
						onlyIf: function () {
							return _model().ContactInfo.IsIndividual()
									&& v.UnlimitedDrivers();
						},
					},
				});
			}, this);
		});
	});

	ko.computed(function () {
		ko.ignoreDependencies(function () {
			_model().UploadingFiles([]);
		}, this);

		function addUploadingFiles (fileOrFiles) {
			const files = [].concat(ko.unwrap(fileOrFiles));

			_.each(_.filter(files), (f) => {
				if (f.Upload.State() !== 'fulfilled' && f.Upload.State() !== 'rejected') {
					ko.ignoreDependencies(() => {
						_model().UploadingFiles.push(f);
					});
				}
			});
		}

		_.each([
			//_model().ContactInfo.CommentFiles,
			_model().ContactInfo.ComplaintFiles,
			_model().ContactInfo.ConclusionFiles,
			_model().KbmOsago.Policies()[0].Files,
			_model().KbmOsago.Policies()[0].LicenseFilesObverse,
			_model().KbmOsago.Policies()[0].LicenseFilesReverse,
			_model().KbmOsago.Policies()[0].PreviousLicenseFilesObverse,
			_model().KbmOsago.Policies()[0].PreviousLicenseFilesReverse,
			_model().KbmOsago.Policies()[0].CertificateFilesObverse,
			_model().KbmOsago.Policies()[0].CertificateFilesReverse,
		], addUploadingFiles);
	});

	ko.computed(function () {
		_model().ResponseInfo.Email(_model().ContactInfo.xEmail());
		_model().ResponseInfo.By()[0] = _model().ResponseInfo.Type();
	});
	//----------- endregion computed --------------

	_model().WorkingState('working');
	setTimeout(function (){
		_model().isReady(true);
		addRequiredFormKbmModel(_model);
	}, 100);
}

function addRequiredFormKbmModel (_model) {
	const requiredIfEmployeeMode = { required: {
		params: true,
		onlyIf: function () {
			return !_model().EmployeeMode();
		},
	}};
	ko.computed(function () {
		const policy = _model().KbmOsago.Policies()[0];
		//_.each(_model().KbmOsago.Policies(), function(policy){
		_.each(policy.Drivers(), function (driver) {
			ko.ignoreDependencies(function () {
				const requiredDriver = {required: {
					params: true,
					onlyIf: function () {
						return !_model().EmployeeMode()
							&& policy.UnlimitedDriversValue() === 'Limited'
							&& _model().ContactInfo.PersonType() === 'Physical';
					},
				}};
				driver.FirstName.extend(requiredDriver);
				driver.LastName.extend(requiredDriver);
				driver.MiddleName.extend(requiredDriver);
				driver.Birthday.extend(requiredDriver);
				driver.DateIncludeInPolicy.extend(requiredDriver);
				driver.License.extend(requiredDriver);
				driver.PreviousLicense.extend({required: {
					params: true,
					onlyIf: function () {
						return !_model().EmployeeMode()
							&& policy.UnlimitedDriversValue() === 'Limited'
							&& _model().ContactInfo.PersonType() === 'Physical'
							&& !driver.HasNoPreviousLicense();
					},
				}});
			}, this);
		});
		ko.ignoreDependencies(function () {
			const requiredOwnerLegal = {required: {
				params: true,
				onlyIf: function () {
					return !_model().EmployeeMode()
						&& (policy.UnlimitedDriversValue() === 'Unlimited'
							&& _model().ContactInfo.PersonType() === 'Physical'
							&& policy.OwnerIsLegalEntity()
							|| _model().ContactInfo.PersonType() === 'Juridical');
				},
			}};
			const requiredOwnerIndividual = {required: {
				params: true,
				onlyIf: function () {
					return !_model().EmployeeMode()
						&& policy.UnlimitedDriversValue() === 'Unlimited'
						&& _model().ContactInfo.PersonType() === 'Physical'
						&& policy.OwnerIsIndividual();
				},
			}};
			policy.Series.extend(requiredIfEmployeeMode);
			policy.Number.extend(requiredIfEmployeeMode);
			policy.Region.extend(requiredIfEmployeeMode);
				//-----OwnerIndividual//
			policy.OwnerIndividual.FirstName.extend(requiredOwnerIndividual);
			policy.OwnerIndividual.LastName.extend(requiredOwnerIndividual);
			policy.OwnerIndividual.MiddleName.extend(requiredOwnerIndividual);
			policy.OwnerIndividual.DateIncludeInPolicy.extend(requiredOwnerIndividual);
			policy.OwnerIndividual.Birthday.extend(requiredOwnerIndividual);
			policy.OwnerIndividual.PassportSeries.extend({required: {
				params: true,
				onlyIf: function () {
					return !_model().EmployeeMode()
						&& _model().ContactInfo.PersonType() === 'Physical'
						&& (policy.OwnerIsIndividual()
							&& policy.UnlimitedDriversValue() === 'Unlimited'
							|| policy.UnlimitedDriversValue() === 'Limited');
				},
			}});
			policy.OwnerIndividual.PassportNumber.extend({required: {
				params: true,
				onlyIf: function () {
					return !_model().EmployeeMode()
						&& _model().ContactInfo.PersonType() === 'Physical'
						&& (policy.OwnerIsIndividual()
							&& policy.UnlimitedDriversValue() === 'Unlimited'
							|| policy.UnlimitedDriversValue() === 'Limited');
				},
			}});
				//-----OwnerLegal-----//
			policy.OwnerLegalEntity.Name.extend(requiredOwnerLegal);
			policy.OwnerLegalEntity.Inn.extend(requiredOwnerLegal);
			policy.OwnerLegalEntity.DateIncludeInPolicy.extend(requiredOwnerLegal);
				//-----Vehicle -------//
			policy.Vehicle.RegNumber.extend(requiredIfEmployeeMode);
			policy.Vehicle.BodyNumber.extend({required: {
				params: true,
				onlyIf: function () {
					return !_model().EmployeeMode()
						&& Boolean(policy.Vehicle) && policy.Vehicle.VehicleType() === 'BodyNumber';
				},
			}});
			policy.Vehicle.ChassisNumber.extend({required: {
				params: true,
				onlyIf: function () {
					return !_model().EmployeeMode()
						&& Boolean(policy.Vehicle)
						&& policy.Vehicle.VehicleType() === 'ChassisNumber';
				},
			}});
			policy.Vehicle.Vin.extend({required: {
				params: true,
				onlyIf: function () {
					return !_model().EmployeeMode()
						&& Boolean(policy.Vehicle) && policy.Vehicle.VehicleType() === 'Vin';
				},
			}});
		}, this);
		//});
	});
}

module.exports = controller;
